export default "__VITE_ASSET__kec2TeSr__"